export default defineNuxtRouteMiddleware(async () => {
  const { suspensePrerequisite } = useAppInit()
  const { data } = await suspensePrerequisite()
  if (!data?.data?.has_promotions && import.meta.client) {
    return navigateTo({ name: 'home' })
  }
})
